/**
 * DealForgeLogo - Branded logo component
 * DEAL: metallic silver/white gradient
 * FORGE: vibrant gold gradient
 * ™: gold superscript
 */

const DEAL_STYLE = {
  background: 'linear-gradient(175deg, #FFFFFF 0%, #C8C8C8 40%, #E8E8E8 80%, #FFFFFF 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.9))',
};

const FORGE_STYLE = {
  background: 'linear-gradient(175deg, #FFE85C 0%, #D4AF37 45%, #B8860B 80%, #D4AF37 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.9))',
};

const TM_STYLE = {
  color: '#D4AF37',
  verticalAlign: 'super',
  marginLeft: '1px',
  lineHeight: 1,
};

const SIZE_CLASSES = {
  xs:   'text-[11px]',
  sm:   'text-sm',
  md:   'text-xl',
  lg:   'text-2xl',
  xl:   'text-3xl',
  '2xl':'text-4xl',
  '3xl':'text-5xl',
  hero: 'text-6xl md:text-7xl',
};

const PORTAL_SIZE = {
  xs:   '0.72em',
  sm:   '0.65em',
  md:   '0.55em',
  lg:   '0.5em',
  xl:   '0.45em',
  '2xl':'0.42em',
  '3xl':'0.4em',
  hero: '0.35em',
};

/**
 * @param {string} size - xs | sm | md | lg | xl | 2xl | 3xl | hero
 * @param {boolean} showTM - whether to show ™ mark
 * @param {string|null} portal - optional portal type label below (e.g. "Contractor")
 */
export default function DealForgeLogo({ size = 'md', showTM = true, portal = null }) {
  const fontClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const tmSize = `${PORTAL_SIZE[size] || '0.38em'}`;
  const portalSize = PORTAL_SIZE[size] || '0.45em';

  return (
    <div className="inline-flex flex-col items-start leading-none select-none">
      <span className={`font-black uppercase tracking-tight leading-none inline-flex items-baseline ${fontClass}`}>
        <span style={DEAL_STYLE}>DEAL</span>
        <span style={FORGE_STYLE}>FORGE</span>
        {showTM && (
          <sup style={{ ...TM_STYLE, fontSize: tmSize }}>™</sup>
        )}
      </span>
      {portal && (
        <span
          className="uppercase tracking-[0.2em] font-semibold mt-0.5"
          style={{ fontSize: portalSize, color: 'rgba(255,255,255,0.3)', letterSpacing: '0.15em' }}
        >
          {portal} Portal
        </span>
      )}
    </div>
  );
}

/**
 * Collapsed icon version — DF monogram in gold
 */
export function DealForgeIcon({ className = "" }) {
  return (
    <span
      className={`font-black uppercase tracking-tight leading-none select-none ${className}`}
      style={{
        background: 'linear-gradient(175deg, #FFE85C 0%, #D4AF37 60%, #B8860B 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.9))',
      }}
    >
      DF
    </span>
  );
}
